import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from '../../context/LanguageContext';
import iconEducation from '../../assets/icons/education.png';
import iconInsurance from '../../assets/icons/insurance.png';
import iconWork from '../../assets/icons/work.png';
import { careersHeroImage } from '../../assets/siteImages';
import { cardStagger, fadeUp, scrollViewport } from '../../motion/presets';
import '../../components/home-focus/home-focus.scss';
import '../../styles/page-hero-media.scss';
import './careers.scss';

const OFFERING_META = [
  { id: 'manpower', theme: 'work', icon: iconWork },
  { id: 'listings', theme: 'education', icon: iconEducation },
  { id: 'partner', theme: 'insurance', icon: iconInsurance },
];

const Careers = () => {
  const { content } = useTranslation();
  const p = content.careersPage;

  return (
    <main className="careers-page">
      <section className="careers-hero section-full" aria-labelledby="careers-hero-title">
        <div className="container page-hero-split">
          <div className="page-hero-split__copy">
            <motion.p
              className="careers-hero__eyebrow"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroEyebrow}
            </motion.p>
            <motion.h1
              id="careers-hero-title"
              className="careers-hero__title"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroTitle}
            </motion.h1>
            <motion.p
              className="careers-hero__lead"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroLead}
            </motion.p>
            <motion.p
              className="careers-hero__trust"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroTrust}
            </motion.p>
            <motion.div
              className="careers-hero__cta"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              <Link className="btn btn-primary careers-hero__btn" to="/contact?purpose=job">
                {p.contactNow}
              </Link>
            </motion.div>
          </div>
          <motion.figure
            className="page-hero-split__media"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            <img
              className="page-hero-split__photo"
              src={careersHeroImage}
              alt={p.heroPhotoAlt}
              loading="eager"
              decoding="async"
            />
          </motion.figure>
        </div>
      </section>

      <section className="careers-cities section-full" aria-labelledby="careers-cities-title">
        <div className="container">
          <motion.h2
            id="careers-cities-title"
            className="careers-cities__title"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            {p.citiesTitle}
          </motion.h2>
          <motion.p
            className="careers-cities__lead"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            {p.citiesLead}
          </motion.p>
          <motion.ul
            className="careers-cities__pills"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            {p.cities.map((city) => (
              <li key={city}>{city}</li>
            ))}
          </motion.ul>
        </div>
      </section>

      <section className="careers-offers section-full" aria-labelledby="careers-offers-title">
        <div className="container">
          <motion.h2
            id="careers-offers-title"
            className="careers-offers__title"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            {p.offersTitle}
          </motion.h2>
          <motion.div
            className="home-focus__grid careers-offers__grid"
            variants={cardStagger}
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
          >
            {OFFERING_META.map((meta, i) => {
              const copy = p.offerings[i];
              return (
                <motion.article
                  key={meta.id}
                  className={`home-focus__card home-focus__card--${meta.theme}`}
                  variants={fadeUp}
                >
                  <div className="home-focus__card-top">
                    <div className="home-focus__icon-wrap" aria-hidden="true">
                      <img
                        src={meta.icon}
                        alt=""
                        className="home-focus__icon"
                        width={56}
                        height={56}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  </div>
                  <h3 className="home-focus__card-title">{copy.title}</h3>
                  <p className="home-focus__card-text">{copy.body}</p>
                  <Link className="home-focus__card-link" to="/contact?purpose=job">
                    {p.contactNow} <span aria-hidden="true">→</span>
                  </Link>
                </motion.article>
              );
            })}
          </motion.div>
        </div>
      </section>

      <section className="careers-special section-full" aria-labelledby="careers-special-title">
        <div className="container careers-special__inner">
          <motion.h2
            id="careers-special-title"
            className="careers-special__title"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            {p.specialTitle}
          </motion.h2>
          <motion.p
            className="careers-special__text"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            {p.specialText}
          </motion.p>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            <Link className="btn btn-primary careers-special__btn" to="/contact?purpose=job">
              {p.contactNow}
            </Link>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default Careers;
